module.exports = __webpack_public_path__ + "static/media/check.b67fb6aa.svg";